<template>
  <div class="page-container">
      <div class="page-wrapper">
          <div class="wrapper">

            <div class="page-content">
              <div class="tools" v-if="this.isAuthenticated">


                <button class="btn circle large" @click="updateContent(pageData)">
                  <span class="tooltip">Mettre à jour</span><i class="fa fa-refresh"></i>
                </button>
              </div>

              <div class="tools" v-if="this.isAuthenticated && pageType !== 'Home' && lang == 'en'" style="right: 535px; bottom: 58px;">
                <button class="btn circle medium" @click="copyFromFrench(pageData)">
                  <span class="tooltip">Copier le contenu en français</span><i class="fa fa-language"></i>
                </button>
              </div>

          <!-- TITLE -->
              <template v-if="this.isAuthenticated">
                <div style=" z-index: 5" class="hr-wrapper" :class="{'title-wrapper': pageType !== 'Home'}">
                  <h1 v-if="loading">
                    <div class="spacer"></div>
                    <clip-loader style="text-align:left" :loading="loading" :color="'black'" :size="'0.8em'"></clip-loader>
                  </h1>
                  <span v-if="pageType !== 'Home' && lang === 'fr'" class="breadcrumb"><h4>{{pageData.parentTitle}}</h4></span>
                 <span v-else-if="pageType !== 'Home' && lang === 'en'" class="breadcrumb"><h4>{{pageData.parentTitle_en}}</h4></span>

                  <h1 style="z-index: 3" v-if="pageData.niceTitle || pageData.niceTitle_en" :class="{'site-title': pageType === 'Home'}">
                    <froala :config="titleEditor" v-if="lang === 'fr'" v-model="pageData.niceTitle"></froala>
                    <froala :config="titleEditor" v-else-if="lang === 'en'" v-model="pageData.niceTitle_en"></froala>
                  </h1>
                  <div v-if="pageType !== 'Home'" class="spacer"></div>
                </div>
              </template>
              <template v-else>
                <div style=" z-index: 5" class="hr-wrapper" :class="{'title-wrapper': pageType !== 'Home'}">
                    <h1 v-if="loading">
                      <div class="spacer"></div>
                      <clip-loader style="text-align:left" :loading="loading" :color="'black'" :size="'0.8em'"></clip-loader>
                    </h1>
                    <span v-if="pageType !== 'Home' && lang === 'fr'" class="breadcrumb"><h4>{{pageData.parentTitle}}</h4></span>
                   <span v-else-if="pageType !== 'Home' && lang === 'en'" class="breadcrumb"><h4>{{pageData.parentTitle_en}}</h4></span>
                    <h1 v-if="lang === 'fr'" v-html="pageData.niceTitle"  :class="{'site-title': pageType === 'Home'}"></h1>
                    <h1 v-else-if="lang === 'en'" v-html="pageData.niceTitle_en"  :class="{'site-title': pageType === 'Home'}"></h1>
                    <div v-if="pageType !== 'Home'" class="spacer"></div>
                </div>
              </template>

              <!-- INTRO + CONTENT-->

              <template v-if="this.isAuthenticated">
                <div style="z-index: 3" class="hr-wrapper">
                  <froala :config="introEditor" v-if="lang === 'fr'" v-model="pageData.introduction"></froala>
                  <froala :config="introEditor" v-else-if="lang === 'en'" v-model="pageData.introduction_en"></froala>
                </div>
                <div class="hr-wrapper" style=" z-index: 3" v-if="(pageType === 'Home' && lang === 'en') || pageType === 'Page' || pageType === 'Membre'">
                  <div class="clearfix">
                    <div class="main-column">
                      <froala :config="contentEditor" v-if="lang === 'fr'" v-model="pageData.content"></froala>
                      <froala :config="contentEditor" v-else-if="lang === 'en'" v-model="pageData.content_en"></froala>
                    </div>
                    <div class="side-column sticky">
                        <froala :config="contentEditor" v-if="lang === 'fr'" v-model="pageData.sideContent"></froala>
                        <froala :config="contentEditor" v-else-if="lang === 'en'" v-model="pageData.sideContent_en"></froala>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>

                <div style=" z-index: 5" class="hr-wrapper" v-if="pageData.introduction">
                  <froalaView v-if="lang === 'fr' && pageData.introduction" v-html="pageData.introduction"></froalaView>
                  <froalaView v-else-if="lang === 'en' && pageData.introduction_en" v-html="pageData.introduction_en"></froalaView>
                </div>
                <div class="hr-wrapper" style=" z-index: 5" v-if="(pageType === 'Home' && lang === 'en') || pageType === 'Page' || pageType === 'Membre'">
                  <div class="clearfix">
                    <div class="main-column">
                      <froalaView v-if="lang === 'fr' && pageData.content" v-html="pageData.content"></froalaView>
                      <froalaView v-else-if="lang === 'en' && pageData.content_en" v-html="pageData.content_en"></froalaView>
                    </div>
                    <div class="side-column sticky" v-if="pageData.sideContent">
                      <froalaView v-if="lang === 'fr' && pageData.sideContent" v-html="pageData.sideContent"></froalaView>
                      <froalaView v-else-if="lang === 'en' && pageData.sideContent_en" v-html="pageData.sideContent_en"></froalaView>


                    </div>
                  </div>
                </div>
              </template>

              <!-- NEWS -->
      
              <div class="news-container" style="z-index: 5" v-if="(pageType === 'Home' && lang === 'fr')">

                  <div class="news-grid">
                      <div class="grid-border"></div>
                      <div class="grid-border"></div>
                      <div class="grid-border"></div>
                  </div>
                    <template v-if="this.isAuthenticated">

                      <grid-layout v-if="pageData.postListData" style="z-index:3"
                      :layout="pageData.postListData" :col-num="3" :row-height="1" :is-draggable="true" :use-css-transforms="false"
                      :is-resizable="false" :margin="[0, 0]">
                          <grid-item v-for="(item,index) in pageData.postListData" :key="item.i"
                            :x="item.x" :y="item.y" :w="1" :h="item.h" :i="item.i" :drag-allow-from="'.dragger'">
                            <div class="news-wrapper">
                              <resizable>
                                <div class="dragger" style="position:relative; float: right; font-size:14px; padding: 5px; z-index: 999; line-height: 1.3;"><i class="fa fa-arrows"></i></div>
                                <button @click="showDeleteNewsItemModal(index)" style="position:relative; float: right; font-size:14px; padding: 5px; z-index: 999"><i class="fa fa-trash"></i></button>
                                <button @click="showArchiveNewsItemModal(index)" style="position:relative; float: right; font-size:14px; padding: 5px; z-index: 999"><i class="fa fa-archive"></i></button>
                                <div class="hr-wrapper">
                                    <div class="news-header">
                                        <h4><froala :config="titleEditor" v-model="item.type"></froala></h4>
                                        <froala :config="titleEditor" v-model="item.date"></froala>
                                    </div>
                                    <froala :config="introEditor" v-model="item.title"></froala>
                                    <froala :config="contentEditor" v-model="item.content"></froala>
                                    <div class="spacer"></div>
                                </div> 
                              </resizable>
                            </div>
                          </grid-item>
                      </grid-layout>

                      <button @click="addNews" class="btn normal" style="width: 100%; text-align: center;"><i class="fa fa-plus"></i>&nbsp;Ajouter une actu</button>
          
                    </template>
                    <template v-else>
                      <grid-layout v-if="pageData.postListData"
                      :layout="pageData.postListData" :col-num="3" :row-height="1" :is-draggable="false"
                      :is-resizable="false" :margin="[0, 0]">
                          <grid-item v-for="item in pageData.postListData"
                            :x="item.x" :y="item.y" :w="1" :h="item.h" :i="item.i" :key="item.i">
                            <div class="news-wrapper">
                              <Resizable>
                                <div class="hr-wrapper">
                                    <div class="news-header">
                                      <h4><froalaView v-if="item.type" v-model="item.type"></froalaView></h4>
                                      <froalaView v-if="item.date" :tag="p" v-model="item.date"></froalaView>
                                    </div>
                                    <froalaView v-if="item.title" v-model="item.title"></froalaView>
                                    <froalaView v-if="item.content" v-model="item.content"></froalaView>
                                    <div class="spacer"></div>
                                </div> 
                              </Resizable>
                            </div>
                          </grid-item>
                      </grid-layout>
                    </template>
                  </div>

                </div>
            </div>
          </div>

        <!--  DELETE NEWS MODAL-->  
        <Modal :show="deleteNewsItemModal.show" @close="deleteNewsItemModal.show = true" style="position:fixed">
          <div>
            <div class="modal-header">
                <h3>Supprimer cette actualité ?</h3>
            </div>
            <div class="modal-footer text-left">
                <button class="btn normal" @click="deleteNewsItemModal.show = false">Annuler</button>
                <button class="btn normal" @click="deleteNewsItem()">OK</button>
            </div>
          </div>
        </Modal>

        <!--  ARCHIVE NEWS MODAL-->  
        <Modal :show="archiveNewsItemModal.show" @close="archiveNewsItemModal.show = false" style="position:fixed">
          <div>
            <div class="modal-header">
                <h3>Archiver cette actualité ?</h3>
            </div>
            <div class="modal-footer text-left">
                <button class="btn normal" @click="archiveNewsItemModal.show = false">Annuler</button>
                <button class="btn normal" @click="archiveNewsItem()">OK</button>
            </div>
          </div>
        </Modal>

      </div>
</template>

<script>


const Resizable = {
  mounted(){
    const vm = this
    this.gridItem = this.$parent
    this.resizeSensor = new ResizeSensor(this.$el, () => {
      const widgetHeight = this.$el.clientHeight
      if (widgetHeight !== vm.widgetHeight) {
        const h = Math.ceil((widgetHeight + vm.gridItem.margin[1]) / (vm.gridItem.rowHeight + vm.gridItem.margin[1]))
        const newH = h
        vm.widgetHeight = widgetHeight
        vm.gridItem.eventBus.$emit(
            'resizeEvent',
            'resizeend',
            vm.gridItem.i,
            vm.gridItem.x,
            vm.gridItem.y,
            newH,
            vm.gridItem.w,
          )
      }
    })

    this.widgetHeight = this.$el.clientHeight
  },
  data(){
    return {
        resizeSensor: null,
        clientHeight: null,
    }
  },
  render(h){
    return h(
      'div', 
      this.$slots.default // tableau des enfants
    )
  }
}

var GridLayout = VueGridLayout.GridLayout
var GridItem = VueGridLayout.GridItem

import axios from 'axios'
import { mapGetters } from 'vuex'
import VueGridLayout from 'vue-grid-layout'
import Modal from './UI/Modal'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'Page',
  components: {
    "GridLayout": GridLayout,
    "GridItem": GridItem,
    Resizable,
    Modal,
    ClipLoader
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userAuthenticated'
    ]),
    pageType () {
      if (this.$route.name === 'Home') {
        return 'Home'
      } else if (this.$route.name === 'Page') {
        return 'Page'
      } else if (this.$route.name === 'Membre') {
        return 'Membre'
      } else if (this.$route.name === 'Recherche') {
        return 'Recherche'
      }
    }
  },
  metaInfo () {
      if (this.pageType !== 'Home' && !this.loading) {
        return {
          title: this.pageData.title + ' | ' + 'Arts en résidence – Réseau National',
          meta: [
            { 'name': 'description', 'content': this.pageData.introduction, 'vmid': 'description' },
            { 'property': 'og:description', 'content': this.pageData.introduction, 'vmid': 'description' }
          ]
        }
      } else {
        return {
          title: 'Arts en résidence – Réseau National',
          meta: [
            { 'name': 'description', 'content': this.pageData.introduction, 'vmid': 'description' },
            { 'property': 'og:description', 'content': this.pageData.introduction, 'vmid': 'description' }
          ]
        }      
      }
  },
  data () {
    return {
      loading: true,
      notOnMap: false,
      lang: global.lang,
      pageData: {},
      deleteNewsItemModal: {
        show: false,
        index: 0
      },
      archiveNewsItemModal: {
        show: false,
        index: 0
      },
      titleEditor: {
        toolbarInline: true,
        language: 'fr',
        key: 'FE3F1G2B2uB5A2A1C3A5F1G4E1J4A16htdckA-8tiynwA-13eoafH3ct==',
        toolbarButtons: ['paragraphFormat'],
        charCounterCount: false,
        htmlDoNotWrapTags: ['h1'],
        paragraphFormat: {
          N: 'Normal'
        },
        paragraphFormatDefaultSelection: 'Normal'
      },
      introEditor: {
        toolbarInline: true,
        key: 'FE3F1G2B2uB5A2A1C3A5F1G4E1J4A16htdckA-8tiynwA-13eoafH3ct==',
        language: 'fr',
        imagePaste: false,
        toolbarButtons: ['bold', 'italic', 'superscript', 'insertLink'],
        quickInsertButtons: [],
        imageResize: false,
        paragraphFormat: {
          N: 'Normal'
        },
        paragraphMultipleStyles: false,
        charCounterCount: false
      },
      contentEditor: {
        toolbarInline: true,
        key: 'FE3F1G2B2uB5A2A1C3A5F1G4E1J4A16htdckA-8tiynwA-13eoafH3ct==',
        language: 'fr',
        imagePaste: false,
        toolbarButtons: ['bold', 'italic', 'superscript', 'paragraphFormat', 'paragraphStyle', 'insertHR', '|', 'insertImage', 'insertVideo', 'insertFile', 'insertLink', '|', 'clearFormatting'],
        quickInsertButtons: [],
        imageResize: false,
        fileUseSelectedText: true,
        paragraphFormat: {
          N: 'Normal',
          H4: 'Titre'
        },
        paragraphStyles: '',        
        quickInsertButtons: ['image', 'video', 'file', 'link'],
        imageEditButtons: ['imageReplace', 'imageRemove', 'imageCaption', 'imageStyle', 'imageLink'],
        imageStyles: {
          fr_img_logo: 'Logo'
        },
        imageResize: false,
        paragraphMultipleStyles: false,
        charCounterCount: false,
        imageUploadURL: '/api/image',
        fileUploadURL: '/api/file',
        fileMaxSize: 20000000,
        imageUploadParams: {maxSize: 1100},
        requestHeaders: {
          Authorization: `Bearer ${localStorage.getItem('user-token')}`
        },
        imageDefaultWidth: 0
      }

    }
  },
  methods: {
    getContent () {
      this.loading = true
      var url = this.$route.path
      var apiUrl;


      if (global.lang === 'en'){
        if (url.split('/').length > 3){
          apiUrl = '/' + url.split('/')[2] + '/' + url.split('/')[3]
        }else if (url.split('/').length > 2){
          apiUrl = '/' + url.split('/')[2]
        }else{
          apiUrl = '/';
        }
      }else{
        apiUrl = url;
      }

      this.lang = global.lang

      this.pageData = {
        introduction:'',
        introduction_en:'',
        content:'',
        content_en:'',
        sideContent:'',
        sideContent_en:''

      }
      return new Promise(function (resolve, reject) {
        axios.get('/api/page' + apiUrl).then(response => {
          function isJson (str) { try { JSON.parse(str) } catch (e) { return false } return true }
          var pageDataObj = response.data
          Object.keys(pageDataObj).forEach(function (key) {
            if (isJson(pageDataObj[key])) {
              pageDataObj[key] = JSON.parse(pageDataObj[key])
            }
          })
          this.pageData = pageDataObj
          this.$emit('refreshMap', { pageType: this.pageType, location: this.pageData.location })
          resolve()
          this.loading = false
        })
        .catch(error => {
          reject(error)
        })
      }.bind(this))
    },
    copyFromFrench() {
        this.pageData.title_en = this.pageData.title;
        this.pageData.introduction_en = this.pageData.introduction;
        this.pageData.niceTitle_en = this.pageData.niceTitle;
        this.pageData.content_en = this.pageData.content;
        this.pageData.sideContent_en = this.pageData.sideContent;
        this.updateContent(this.pageData);
        this.getContent()
    },
    updateContent (params) {
      var url = this.$route.path
      var apiUrl;


      if (global.lang === 'en'){
        if (url.split('/').length > 3){
          apiUrl = '/' + url.split('/')[2] + '/' + url.split('/')[3]
        }else if (url.split('/').length > 2){
          apiUrl = '/' + url.split('/')[2]
        }else{
          apiUrl = '/';
        }
      }else{
        apiUrl = url;
      }

      this.lang = global.lang

      if (this.pageType === 'Membre') {
        this.pageData.location = {
          long: map.getCenter().lng,
          lat: map.getCenter().lat,
          zoom: map.getZoom(),
          notOnMap: this.notOnMap
        }
      }
      var pageDataObj = {}

      if (!this.pageData.title_en && this.pageData.niceTitle_en){
        this.pageData.title_en = this.pageData.niceTitle_en.replace(/<\/?[^>]+>/ig, " ");
      }

      Object.keys(this.pageData).forEach(function (key) {
        if (typeof this.pageData[key] === 'object' || typeof this.pageData[key] === 'array') {
          var stringifiedKey = JSON.stringify(this.pageData[key])
          pageDataObj[key] = stringifiedKey
        }else{
          pageDataObj[key] = this.pageData[key]
        }
      }.bind(this))

      console.log(pageDataObj)

      return new Promise(function (resolve, reject) {
        axios.put('/api/page' + apiUrl, pageDataObj).then(response => {
      console.log(response)
          this.$notify({title: 'La page est à jour !'})
          resolve()
        })
        .catch(error => {
          this.$notify({title: this.pageData.niceTitle, text: error.data})
          reject(error)
        })
      }.bind(this))
    },
    showDeleteNewsItemModal(index) {
      this.deleteNewsItemModal.show = true
      this.deleteNewsItemModal.index = index
    },
    showArchiveNewsItemModal(index) {
      this.archiveNewsItemModal.show = true
      this.archiveNewsItemModal.index = index
    },
    addNews () {
      var newsObj = {'type':'','date':''+getTodayDate()+'','title':'','content':'','x':0,'y':-0.1,'w':1,'h':160,'i':''+newUID()+'','moved':false}
      this.pageData.postListData.push(newsObj)
    },
    deleteNewsItem () {
      var index = this.deleteNewsItemModal.index
      this.pageData.postListData.splice(index, 1)
      this.$notify({title: 'Le post à été supprimé'})
      this.updateContent()
      this.deleteNewsItemModal.show = false
    },
    archiveNewsItem () {
      var index = this.archiveNewsItemModal.index
      var objectToArchive = this.pageData.postListData[index]
      this.pageData.postListData.splice(index, 1)
      // get the archive List
      axios.get('/api/page/archives').then((response) => {
        var archivedPostListData = JSON.parse(response.data.archivedPostListData)
        // push the deleted post
        archivedPostListData.push(objectToArchive)
        // update the archived post list
        var params = {
          archivedPostListData: JSON.stringify(archivedPostListData)
        }
        axios.put('/api/page/archives', params).then((response) => {
          this.$notify({title: 'Le post à été archivé'})
        })
      })
      this.updateContent()
      this.archiveNewsItemModal.show = false
    }

  },

  created () {
    this.getContent().then(response => {
      console.log('Content Loaded')
    })
    
    if (app.$route.path.split('/')[1] == 'en'){
      global.lang = 'en'
    }else{
      global.lang = 'fr'
    }
    this.lang = global.lang

  },
  watch: {
    $route () {
      this.getContent().then(response => {
        console.log('Content Loaded')
      })
      if (app.$route.path.split('/')[1] == 'en'){
        global.lang = 'en'
      }else{
        global.lang = 'fr'
      }
      this.lang = global.lang
    }
  }
}
</script>

<style lang="scss">

.item {
  height: 100%;
}

.vue-grid-item{
  transition: 0s !important;
}

.vue-grid-item.vue-draggable-dragging {
    opacity: 0.5;
}

.vue-grid-item.vue-grid-placeholder {
  background: yellow;
}

</style>



// WEBPACK FOOTER //
// src/components/Page.vue